import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Lots} from './lots';
import {SerialNumber} from './serial-number-type';
import {ProductsArticle} from './products-article';

@Injectable()
export class StocksService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private api_url_get_lots = './api/server.php?cmd=GET_LOTS';
    private api_url_get_serial_number = './api/server.php?cmd=GET_SERIAL_NUMBER';
    private api_url_session_receipt = './api/server.php?cmd=SESSION_RECEIPT';
    private api_url_session_issue = './api/server.php?cmd=SESSION_ISSUE';
    private api_url_receip_stocks = './api/server.php?cmd=RECEIPT_STOCK';
    private api_url_issue_stocks = './api/server.php?cmd=ISSUE_STOCK';
    private api_url_verify_serial_number_in_out = './api/server.php?cmd=VERIFY_SERIAL_NUMBER_IN_OUT';
    private api_url_verify_serial_number_out = './api/server.php?cmd=VERIFY_SERIAL_NUMBER_OUT';
    private api_url_receipt_docket = './api/server.php?cmd=RECEIPT_DOCKET';
    private api_url_issue_docket = './api/server.php?cmd=ISSUE_DOCKET';
    private api_url_load_receipt_session_docket = './api/server.php?cmd=RECEIPT_SESSION_DOCKET';
    private api_url_load_issue_session_docket = './api/server.php?cmd=ISSUE_SESSION_DOCKET';
    private api_url_remove_article_session_receipt = './api/server.php?cmd=DELETE_SESSION_RECEIPT';
    private api_url_remove_article_session_issue = './api/server.php?cmd=DELETE_SESSION_ISSUE';
    private api_url_modify_this_article_session_receipt = './api/server.php?cmd=MODIFY_SESSION_RECEIPT';
    private api_url_modify_this_article_session_receipt_bcf = './api/server.php?cmd=MODIFY_SERIAL_NUMBER_PURCHASE_DETAIL_BCF';
    private api_url_modify_this_article_session_receipt_os = './api/server.php?cmd=MODIFY_SERIAL_NUMBER_OS_DETAIL';
    private api_url_modify_this_article_session_issue = './api/server.php?cmd=MODIFY_SESSION_ISSUE';
    private api_url_validate_modification_article_session_receipt = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_RECEIPT';
    private api_url_validate_modification_article_session_issue = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_ISSUE';
    private api_url_is_avalbale_serial_number = './api/server.php?cmd=IS_AVAILABLE_SERIAL_NUMBER_PURCHASE_DETAIL_BCF';
    private api_url_is_avalbale_serial_number_os = './api/server.php?cmd=IS_AVAILABLE_SERIAL_NUMBER_OS_DETAIL';
    private api_url_cancel_enter_stock = './api/server.php?cmd=CANCEL_ENTER_STOCK';
    private api_url_cancel_enter_init_stock = './api/server.php?cmd=CANCEL_RECEIPT_DOCKET';

    private name: string;
    private id_lot: number;

    constructor(private http: Http) {}

    CancelEnterStock(): Promise<Object> {
        return this.http.get(this.api_url_cancel_enter_stock)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    CancelEnterInitialStock(): Promise<Object> {
        return this.http.get(this.api_url_cancel_enter_init_stock)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    IsAvalableSerialNumber(article: any): Promise<Object> {
        return this.http.get(this.api_url_is_avalbale_serial_number + '&index=' + article.index + '&serial_number=' + article.serial + '&id_article=' + article.id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    //ReceiptSessionDocket
    LoadSessionDocket(): Promise<Object> {
        return this.http.get(this.api_url_load_receipt_session_docket)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    LoadSessionIssueDocket(): Promise<Object> {
        return this.http.get(this.api_url_load_issue_session_docket)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetLotsList(id_article: number): Promise<Lots[]> {
        return this.http.get(this.api_url_get_lots + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Lots[])
            .catch(this.handleError);
    }

    GetSerialList(id_article: number): Promise<SerialNumber[]> {
        return this.http.get(this.api_url_get_serial_number + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as SerialNumber[])
            .catch(this.handleError);
    }

    SessionReceipt(id_article: number, name: string, quantity: string, lot: string, serial_number: string, article_management: string): Promise<Object> {
        return this.http.get(this.api_url_session_receipt + '&id_article=' + id_article + '&name=' + name + '&quantity=' + quantity + '&lot=' + lot + '&serial_number=' + serial_number + '&management_mode=' + article_management)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionReceipt(index: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_receipt + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionReceiptBcf(index: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_receipt_bcf + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionReceiptOs(index: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_receipt_os + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionIssue(index: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_issue + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionReceipt(prod: any): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_article_session_receipt + '&index=' + prod.index + '&id_article=' + prod.id_article + '&name=' + prod.name + '&quantity=' + prod.quantity + '&serial_number=' + prod.serial_number + '&lot=' + prod.lot)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionReceiptPopup(article: any): Promise<Object> {
        return this.http.get(this.api_url_is_avalbale_serial_number + '&index=' + article.index + '&serial_number=' + article.serial + '&id_article=' + article.id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionIssuePopup(article: any): Promise<Object> {
        return this.http.get(this.api_url_is_avalbale_serial_number_os + '&index=' + article.index + '&serial_number=' + article.serial + '&id_article=' + article.id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionIssue(prod: any): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_article_session_issue + '&index=' + prod.index + '&id_article=' + prod.id_article + '&name=' + prod.name + '&quantity=' + prod.quantity + '&serial_number=' + prod.serial_number + '&lot=' + prod.lot)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveArticleSessionReceipt(index: string): Promise<Object> {
        return this.http.get(this.api_url_remove_article_session_receipt + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveArticleSessionIssue(index: string): Promise<Object> {
        return this.http.get(this.api_url_remove_article_session_issue + '&index=' + index)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    SessionIssue(id_article: number, name: string, quantity: number, serial_number: string, management_mode: string): Promise<Object> {
        return this.http.get(this.api_url_session_issue + '&id_article=' + id_article + '&name=' + name + '&quantity=' + quantity + '&serial_number=' + serial_number + '&management_mode=' + management_mode)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ReceipStoks(id_article: number, quantity: string, lot: string, serial_number: string): Promise<ProductsArticle[]> {

        return this.http.get(this.api_url_receip_stocks + '&id_article=' + id_article + '&name=' + name + '&quantity=' + quantity + '&lot=' + lot + '&serial_number=' + serial_number)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ReceiptDocket(docket_name: string, article_abstract_id: number): Promise<ProductsArticle[]> {
        return this.http.get(this.api_url_receipt_docket
            + '&docket_name=' + docket_name
            + '&article_abstract_id=' + article_abstract_id
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    IssueDocket(docket_name: string, article_abstract_id: number): Promise<ProductsArticle[]> {
        return this.http.get(this.api_url_issue_docket + '&docket_name=' + docket_name + '&article_abstract_id=' + article_abstract_id)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    IssueStocks(id_article: number, quantity: number, serial_number: string): Promise<ProductsArticle[]> {
        return this.http.get(this.api_url_issue_stocks + '&id_article=' + id_article + '&quantity=' + quantity + '&serial_number=' + serial_number)
            .toPromise()
            .then(response => response.json() as ProductsArticle[])
            .catch(this.handleError);
    }

    VerificationSerialNumberInOut(id_article: number, serial_value: string): Promise<string> {
        return this.http.get(this.api_url_verify_serial_number_in_out + '&id_article=' + id_article + '&serial_value=' + serial_value)
            .toPromise()
            .then(response => response.json() as string)
            .catch(this.handleError);
    }

    VerificationSerialNumberOut(id_article: number, serial_value: string): Promise<string> {
        return this.http.get(this.api_url_verify_serial_number_out + '&id_article=' + id_article + '&serial_value=' + serial_value)
            .toPromise()
            .then(response => response.json() as string)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/stocks.service.ts